import Vue from 'vue'
import {
	Message
} from 'element-ui'

/**权限控制**/
Vue.directive('permission', {
	inserted: function(el, binding, vnode) {
		let btnPermissionList = [];
		let btnPermissionData = localStorage.getItem("btnPermissionList");
		if (btnPermissionData != undefined && btnPermissionData != null || btnPermissionData
			.length > 0) {
			btnPermissionList = JSON.parse(btnPermissionData);
		}

		let isSuper = false;
		let userinfo = JSON.parse(localStorage.getItem("userInfo"));
		if (userinfo != undefined && userinfo != null && Object.keys(userinfo).length > 0) {
			if (userinfo.isSuper == 1) {
				isSuper = true;
			}
		}

		var code = el.getAttribute("code");
		let hasAuthority = btnPermissionList.includes(code);
		//权限判断元素是否需要在页面上显示，如果没有所需权限，则将元素从页面上移除
		if (!hasAuthority && !isSuper) {
			el.parentNode && el.parentNode.removeChild(el);
		}

	}
});